import { MantineProvider } from '@mantine/core'
import React from 'react'
import { I18nextProvider } from 'react-i18next'

import { FIVE_MB_FILE_SIZE, IMAGE_MIME_TYPES } from '../constants'
import i18n from '../i18n'
import { DnDUploaderProps } from '../types/dnd-uploader'
import DropZone from './Dropzone'

const TollesFeature = ({
  acceptedMimeTypes = IMAGE_MIME_TYPES,
  allowedFileSize = FIVE_MB_FILE_SIZE,
  maxFiles = 5,
  currentFileCount = 2,
  onAssetAdded,
  innerGroupOverrideProps = {},
  dropzoneOverrideProps = {},
  mantineThemeOverride = {},
  disableIfLimitReached = true,
}: DnDUploaderProps): React.ReactElement => {
  if (disableIfLimitReached && currentFileCount >= maxFiles) {
    return <></>
  }

  return (
    <MantineProvider theme={mantineThemeOverride}>
      <I18nextProvider i18n={i18n}>
        <DropZone
          allowedFileSize={allowedFileSize}
          acceptedMimeTypes={acceptedMimeTypes}
          maxFiles={maxFiles}
          currentFileCount={currentFileCount}
          onAssetAdded={onAssetAdded}
          innerGroupOverrideProps={innerGroupOverrideProps}
          dropzoneOverrideProps={dropzoneOverrideProps}
        />
      </I18nextProvider>
    </MantineProvider>
  )
}

export default TollesFeature
